import BaseDialog from "@/components/BaseDialog";

// 素材预览 弹窗
export function storePreviewModal({ props, cbs, on}) {
    return new BaseDialog({
        component: ()=>import('./previewMaterialModal.vue'),
        options: {
            top: '10vh',
            width: '60%',
            title: '素材预览',
            closeOnClickModal:false,
        },
        props,
        cbs,
        on
    })
}

// 素材上传与编辑 弹窗
export function uploadMaterialModal({ props, cbs, on }) {
    return new BaseDialog({
        component: ()=>import('./uploadMaterialModal.vue'),
        options: {
            top: '10vh',
            width: '75%',
            title: props.title||'素材上传',
            closeOnPressEscape:false,
            closeOnClickModal:false,
            customClass:props.customClass?props.customClass:'',
        },
        props,
        cbs,
        on
    })
}

// 自定义列 弹窗
export function fieldTableModal({ props, cbs }) {
    return new BaseDialog({
        component: ()=>import('./tableModal.vue'),
        options: {
            top: '10vh',
            width: '75%',
            title: '自定义列',
            closeOnPressEscape:false,
            closeOnClickModal:false,
            customClass:props.customClass?props.customClass:'',
        },
        props,
        cbs,
    })
}


// 工单上传 - 任务尺寸重复弹框
export function repeatSizeModal({ props, cbs }) {
    return new BaseDialog({
        component: ()=>import('./repeatSizeModal.vue'),
        options: {
            top: '10vh',
            width: '750px',
            title: '温馨提示',
            closeOnPressEscape:false,
            closeOnClickModal:false,
            customClass:props.customClass?props.customClass:'',
        },
        props,
        cbs,
    })
}

// 工单上传 - 有正在上传的任务弹窗
export function taskUploadingModal({ props, cbs }) {
    return new BaseDialog({
        component: ()=>import('./taskUploadingModal.vue'),
        options: {
            top: '10vh',
            width: '750px',
            title: '批量上传提示',
            closeOnPressEscape:false,
            closeOnClickModal:false,
            customClass:props.customClass?props.customClass:'',
        },
        props,
        cbs,
    })
}
